import axiosInstance from './AxiosInstance';

export function getCapitalInjections(page = 1) {
    return axiosInstance.get('ledger/capital-injections', { params: { page } });
}

export function initiateCapitalInjection(data) {
    return axiosInstance.post('ledger/capital-injections', data);
}

export function getReconciliationRequiredCapitalInjections(page = 1) {
    return axiosInstance.get('ledger/capital-injections/reconciliation-required', { params: { page } });
}

export function reconcileCapitalInjection(injectionId, data) {
    return axiosInstance.post(`ledger/capital-injections/${injectionId}/reconcile`, data);
}
